import { transformToRenderableElements } from "./EmbeddedCanvasRenderer";

describe("transformToRenderableElements", () => {
  it("injects persisted embedding config into nested embedded canvas elements", () => {
    const [element] = transformToRenderableElements({
      elements: [
        {
          id: "formats-embed",
          element_type: "EMBEDDED_CANVAS",
          config_json: {
            title: "Formats",
            displayMode: "grid",
          },
          grid_column: 1,
          grid_row: 1,
          column_span: 12,
          row_span: 4,
        },
      ],
      embeddings: [
        {
          element_id: "formats-embed",
          child_canvas_id: "formats-canvas",
          parent_data_source_alias: "titles",
          parent_key_field: "id",
          child_data_source_alias: "formats",
          child_filter_field: "title_id",
        },
      ],
    } as any);

    expect(element).toMatchObject({
      id: "formats-embed",
      type: "embedded_canvas",
      gridColumn: 1,
      gridRow: 1,
      columnSpan: 12,
      rowSpan: 4,
      props: {
        title: "Formats",
        displayMode: "grid",
        childCanvasId: "formats-canvas",
        parentDataSourceAlias: "titles",
        parentKeyField: "id",
        childDataSourceAlias: "formats",
        childFilterField: "title_id",
      },
    });
  });

  it("preserves camelCase embedding config from already-normalized canvases", () => {
    const [element] = transformToRenderableElements({
      elements: [
        {
          id: "child-embed",
          type: "embedded_canvas",
          props: {
            title: "Child Canvas",
          },
        },
      ],
      embeddings: [
        {
          elementId: "child-embed",
          childCanvasId: "child-canvas",
          parentDataSourceAlias: "parent",
          parentKeyField: "parent_id",
          childDataSourceAlias: "child",
          childFilterField: "parent_id",
        },
      ],
    } as any);

    expect(element.props).toMatchObject({
      title: "Child Canvas",
      childCanvasId: "child-canvas",
      parentDataSourceAlias: "parent",
      parentKeyField: "parent_id",
      childDataSourceAlias: "child",
      childFilterField: "parent_id",
    });
  });

  it("keeps only visible nested elements and their effective access", () => {
    expect(
      transformToRenderableElements({
        elements: [
          {
            id: "visible",
            element_type: "CONTAINER",
            effective_access: "read",
          },
          {
            id: "visible-child",
            parent_element_id: "visible",
            element_type: "FIELD",
            effective_access: "read",
          },
          { id: "hidden", element_type: "CONTAINER", effective_access: "none" },
          {
            id: "hidden-child",
            parent_element_id: "hidden",
            element_type: "FIELD",
            effective_access: "read-write",
          },
        ],
      } as any).map((element) => [element.id, element.effectiveAccess]),
    ).toEqual([
      ["visible", "read"],
      ["visible-child", "read"],
    ]);
  });
});

it("carries saved visibility and rules into runtime elements", () => {
  const rules = {
    logic: "and",
    conditions: [{ field: "status", operator: "eq", value: "approved" }],
  };
  const [hidden, visible] = transformToRenderableElements({
    elements: [
      {
        id: "hidden",
        element_type: "FIELD",
        is_visible: false,
        visibility_rules: rules,
      },
      { id: "visible", element_type: "FIELD", is_visible: true },
    ],
  } as unknown as Parameters<typeof transformToRenderableElements>[0]);
  expect(hidden).toMatchObject({ isVisible: false, visibilityRules: rules });
  expect(visible).toMatchObject({ isVisible: true });
});
